export function bundleListingColumns(bundleCount: number): 2 | 3 {
  return bundleCount > 0 && (bundleCount % 3 === 0 || bundleCount > 6) ? 3 : 2
}
